import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ApButton from '../Shared/ApButton';
import { useAuth } from '../../contexts/AuthProvider';
import { ApButtonStyle1, ApButtonStyle2 } from 'models/ButtonStyles';
import ShiptoSelect from 'components/ShipToSelect/ShipToSelect';
import { useUserCountry } from 'contexts/UserCountryProvider';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSiteConfig } from 'contexts/SiteConfigProvider';
import HamburgerIcon from './HamburgerIcon';
import ApDropDownMenu from '../Shared/ApDropDownMenu';

function HeaderBar() {
  const { region, country, locale } = useUserCountry();
  const { authenticating, isAuthenticated, logIn } = useAuth();
  const { getBrand, getRegistrationLink } = useSiteConfig();
  const brand = getBrand();
  const registration = () => window.location.replace(getRegistrationLink());
  const intl = useIntl();
  const handleLoginClick = () => logIn();
  const [showMbMenuDetails, setShowMbMenuDetails] = useState(false);
  const handleMobileMenuClick = () => {
    setShowMbMenuDetails(!showMbMenuDetails);
  };
  const ddmHeader = <><span className="hamburger-align" onClick={handleMobileMenuClick}>
    <HamburgerIcon width={25} height={25}></HamburgerIcon>
  </span></>;
  return (
    <Container fluid className="ap-top-menu mb-5">
      <div className="main-container">
        <Row className="ap-top-menu-logo">
          <Col lg={5} md={3} sm={8} xs={7}>
            <a href={`${import.meta.env.VITE_ONLINE_SHOP_BASE_URL}/${region}/${country}/${locale}/`}>
              <img src={brand.headerLogo} alt={brand.brandName} width={brand.headerLogoWidth} height={brand.hearderLogoHeight} />
            </a>
          </Col>
          <Col lg={7} md={9} className="justify-content-end text-end d-none d-sm-done d-md-flex">
            <span className="ap-blue">My</span>
            <span className="ap-green sm-font">{brand.brandName}℠</span>
          </Col>
          <Col sm={4} xs={5} className="justify-content-end text-end d-block d-sm-block d-md-none">
            <ApDropDownMenu header={ddmHeader}
              body={<>
                <div>
                  <button className="mb-1 dropdown-buttons" onClick={() => registration()}>
                    {intl.formatMessage({ id: 'ml_114706', defaultMessage: 'X - Sign up' })}
                  </button>
                </div>
                <div>
                  <button className="dropdown-buttons" onClick={() => handleLoginClick()}>
                    {intl.formatMessage({ id: 'ml_114705', defaultMessage: 'X - Log in' })}
                  </button>
                </div>
              </>}></ApDropDownMenu>
          </Col>
        </Row>
        <Row className="justify-content-end m-0 d-none d-sm-done d-md-flex mt-2">
          {
            authenticating || !isAuthenticated() ?
              (<Col md="auto" className="text-end p-0">
                <ApButton innerText={intl.formatMessage({ id: 'ml_114706', defaultMessage: 'X - Sign up' })} btnStyleOption={{...ApButtonStyle1, className: "gtm-tag-register"}} clickHandler={registration}></ApButton>
                <ApButton innerText={intl.formatMessage({ id: 'ml_114705', defaultMessage: 'X - Log in' })} btnStyleOption={{ ...ApButtonStyle2, className: "ms-5 gtm-tag-login" }} clickHandler={logIn} ></ApButton>
              </Col>) : <Col md={7}>
                <ShiptoSelect></ShiptoSelect>
              </Col>
          }
        </Row>
      </div>
    </Container>
  );
}

export default HeaderBar;